module.exports = __webpack_public_path__ + "static/media/paneerdosa.7503f7b6.jpg";